import { createAction } from '@reduxjs/toolkit';
import { IReportFilter, ReportType } from 'core/slices/report';
import { IUploadFile } from 'core/slices/upload';
import { UploadTypes } from 'types/app/upload';
import { SortBy } from 'types/domain/search';
import { EntityTypes } from '../../../constants/entities';
import { IText } from 'types/domain/text';

export interface IGet {
  entityId?: number;
  type: EntityTypes;
  parentEntityId?: number;
  parentEntityType?: EntityTypes;
  report?: boolean;
}

export interface IList {
  type: EntityTypes;
  parentEntityId?: number;
  parentEntityType?: EntityTypes;
  search?: string;
  sort?: number;
  pagerInfo: IPage;
}

export interface IReportList extends IList {
  reportType?: ReportType;
  filter?: IReportFilter;
}

export interface IPage {
  page: number;
  pageCount?: number;
  totalRecords?: number;
  search?: string;
  sort?: SortBy;
  ids?: number[];
  start?: Date;
  end?: Date;
  days?: number;
  timeZone?: string;
}

export interface ICreate {
  type: EntityTypes;
  entity: any;
  parentEntityId?: number;
  parentEntityType?: EntityTypes;
  parentEntityAttribute?: string;
  parentModuleId?: number;
  parentCourseId?: number;
  parentOrganisationId?: number;
}

export interface IClone extends ICreate {
  token?: string;
}

export interface IUpdate {
  type: EntityTypes;
  entity: any;
  parentEntityId?: number;
  parentEntityType?: EntityTypes;
  parentEntityAttribute?: string;
  parentModuleId?: number;
  parentCourseId?: number;
  persist?: boolean;
  mergeData?: boolean;
}

export interface IEmailRequest {
  courseProgressIds: number[];
  courseNodeId: number;
  subject: string;
  body: IText;
}

export interface IBatch {
  batch: IUpdate[];
}

export interface IUpload {
  files: IUploadFile[];
  parentEntityId?: number;
  parentEntityType?: EntityTypes;
  multi?: boolean;
  type: UploadTypes;
}

export interface IUploadResponse {
  url: string;
  filename: string;
}

export const createNextAction = createAction('admin/create/nextAction', function prepare(entity?: any) {
  return {
    payload: {
      ...(entity || {}),
    },
  };
});

export const createPreviousAction = createAction('admin/create/previousAction', function prepare(entity?: any) {
  return {
    payload: {
      ...(entity || {}),
    },
  };
});

export const update = createAction('admin/update', function prepare(entity: IUpdate) {
  return {
    payload: {
      ...entity,
    },
  };
});
